export default __webpack_public_path__ + "img/b8cf4794b5c23d9bb441cbeeff8d5353.png";